// extracted by mini-css-extract-plugin
module.exports = {"destinationBase":"styles_destinationBase__wCMA0","topDestinationBtn":"styles_topDestinationBtn__k4qnA","iconImage":"styles_iconImage__vjdRv"};